export enum BackendServerAvailability {
  Undecided = 0, //The application did not yet try
  Available,
  Unavailable,
}
